import { useTranslation } from 'react-i18next';
import { CreditCardIcon, DepositLineIcon, PhotoIdIcon } from '../../assets/svgIcon/customIcon';
import './auth.scss';

interface AuthStaticContentProps {
  mobileLoginContent?: boolean;
}

const AuthStaticContent: React.FC<AuthStaticContentProps> = ({ mobileLoginContent }) => {

  const { t } = useTranslation();

  return (
    <div className={`login-page-content`}>
      <div className='login-content'>
        <img className='img-fluid login-logo d-lg-block d-none' src="/images/Renticy-light-logo.png" alt='logo' />
        <img className='img-fluid login-logo d-lg-none d-block' src="/images/logo.svg" alt='logo' />
        <div className={`d-none ${mobileLoginContent ? `login-content-show` : `d-lg-block`}`}>
          <h2>{t('get-ready-for')} Renticy<span>.</span></h2>
          <h5>{t('what-you-will-need')}<span>?</span></h5>
          <div className='login-renticy-steps'>
            <div className='step-box'>
              <div className='step-box-icon'>
                <PhotoIdIcon />
              </div>
              <h6>{t('photo-id')}</h6>
            </div>
            <div className='step-box credit-card'>
              <div className='step-box-icon'>
                <CreditCardIcon />
              </div>
              <h6>{t('payment-card')}</h6>
            </div>
            <div className='step-box deposit-line'>
              <div className='step-box-icon'>
                <DepositLineIcon />
              </div>
              <h6>{t('deposit')}</h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AuthStaticContent